<template>

  <div class="height-100">
    <creating
      v-if="creating"
      height="100%" />

    <div
      v-if="!creating"
      class="hflex">
      <div
        class="hflex-col-2 hflex-options-left"
        :class="{'box-loading': loading}">
        <JobSeekerHead
          style="position: sticky; top: 0; z-index: 1; background-color: white;"
          :tab="tab"
          :isRunning="isRunning"
          @update:tab="tab = $event" />
        <div
          v-if="tab === 'criteria'"
          class="p-3 pb-4">
          <JobSeekerForm
            :model-value="{ ...input, count, auto_adjust_enabled }"
            @submit="handleSubmit"
            @closeChangeReason="changeReason = null"
            :creatingCriteria="creatingCriteria"
            :changeReason="changeReason"
            :isRunning="isRunning"
            :errorMessage="errorMessage"
            @redefineCriteria="handleRedefineCriteria"
            :validateErrors="validateErrors" />
        </div>
        <div
          v-if="tab === 'lastSearch'"
          class="p-3">
          <JobSeekerSearchs
            :searches="webset ? webset.searches : null"
            @redefineCriteria="handleRedefineCriteria"
            @stopSearch="stopSearch" />
        </div>
      </div>
      <div class="hflex-col-5 hflex-options-left">
        <JobSeekerResult
          :webset="webset"
          :job="job"
          :currentProfile="currentProfile"
          :isRunning="isRunning" />
      </div>
    </div>
  </div>

</template>

<script>
import JobSeekerHead from './JobSeekerHead'
import JobSeekerForm from './JobSeekerForm'
import JobSeekerResult from './JobSeekerResult'
import JobSeekerSearchs from './JobSeekerSearchs'

export default {
  name: 'JobSeeker',
  components: {
    JobSeekerHead,
    JobSeekerForm,
    JobSeekerResult,
    JobSeekerSearchs
  },
  props: [
  ],
  data () {
    return {
      tab: 'criteria',
      creating: true,
      loading: false,
      creatingCriteria: false,
      input: {},
      webset: null,
      count: 20,
      auto_adjust_enabled: true,
      isDestroyed: false,
      validateErrors: {},
      changeReason: null,
      errorMessage: null
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    profileId () {
      return this.$route.params.profile_id
    },
    currentProfile () {
      if (this.webset && this.webset.profiles.docs) {
        return this.webset.profiles.docs.find(p => p._id === this.profileId)
      }
      return null
    },
    isRunning () {
      return this.webset && this.webset.status === 'running'
    }
  },
  created () {
    this.loadData()
  },
  beforeDestroy () {
    this.isDestroyed = true
  },
  methods: {
    alertNoCredits () {
      this.$store
      .dispatch('setAlertModal', {
        type: 'ok',
        title: 'Sem créditos para envio de convite para vídeo apresentação.',
        message: 'Contate o administrador.'
      })
    },
    async loadData () {
      try {
        const { data } = await this.axios.get(`/accounts/${this.$store.getters.getAccount._id}/jobs/${this.job._id}/seeker/search`)
        this.input = data.input || {}
        this.webset = data.webset
      } catch (err) {
        console.log(err)
      } finally {
        this.creating = false
        // se não tiver query, reseta critérios
        if (this.input && !this.input.query) {
          await this.handleRedefineCriteria({ type: 'from_job', searchId: null })
        }
        // se tiver buscas rodando, atualiza a cada segundo
        if (this.webset && this.webset.status !== 'idle' && !this.isDestroyed) {
          setTimeout(() => this.loadData(), 1000)
        }
      }
    },
    async handleSubmit (data) {
      try {
        this.loading = true
        this.count = data.count
        this.auto_adjust_enabled = data.auto_adjust_enabled
        this.input = {
          query: data.query,
          criteria: data.criteria
        }
        this.errorMessage = null
        this.validateErrors = {}
        await this.axios.post(`/accounts/${this.$store.getters.getAccount._id}/jobs/${this.job._id}/seeker/search`, {
          query: data.query,
          criteria: data.criteria,
          count: data.count,
          auto_adjust_enabled: data.auto_adjust_enabled
        })
        this.loadData()
        this.tab = 'lastSearch'
      } catch (err) {
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
        if (err.response.data.name === 'Forbidden') {
          this.alertNoCredits()
        }
        if (err.response.data.name === 'BadRequest') {
          this.errorMessage = err.response.data.message
        }
      } finally {
        this.loading = false
      }
    },
    async handleRedefineCriteria ({ type, searchId }) {
      try {
        this.tab = 'criteria'
        this.creatingCriteria = true
        const { data } = await this.axios.post(`/accounts/${this.$store.getters.getAccount._id}/jobs/${this.job._id}/seeker/redefine-criteria`, {
          type,
          search_id: searchId
        })
        console.log(data)
        this.changeReason = data.change_reason
        await this.loadData()
      } catch (err) {
        console.log(err)
      } finally {
        this.creatingCriteria = false
      }
    },
    async stopSearch () {
      try {
        await this.axios.post(`/accounts/${this.$store.getters.getAccount._id}/jobs/${this.job._id}/seeker/stop-search`, {})
        await this.loadData()
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobSeeker/JobSeeker.vue